module.exports = __webpack_public_path__ + "static/img/tubaina-retro.c6b4f69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/thumbs/tubaina-retro.png
// module id = d1a6
// module chunks = 0